<template>
  <span class="course-price" :class="{ 'is-compact': compact }">
    <strong class="current-price">{{ format(course.price, course.currency) }}</strong>
    <template v-if="showOffer">
      <del class="old-price" aria-label="السعر قبل الخصم">{{ compact ? course.original_price : format(course.original_price, course.original_currency || course.currency) }}</del>
      <span class="discount-badge">خصم {{ discountPercent }}%</span>
    </template>
  </span>
</template>

<script>
const CURRENCY_NAMES = {
  EGP: 'جنيه مصري',
  SAR: 'ريال سعودي',
};

export default {
  name: 'CoursePrice',
  props: {
    course: { type: Object, required: true },
    compact: { type: Boolean, default: false },
  },
  computed: {
    showOffer() {
      const { has_offer, original_price, price, original_currency, currency } = this.course;
      return Boolean(has_offer)
        && original_price > price
        && (!original_currency || original_currency === currency);
    },
    discountPercent() {
      return Math.round((1 - this.course.price / this.course.original_price) * 100);
    },
  },
  methods: {
    format(amount, currency) {
      return `${amount} ${CURRENCY_NAMES[currency] || currency || ''}`.trim();
    },
  },
};
</script>

<style scoped>
.course-price {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 8px;
}

.current-price {
  color: var(--brand-teal);
}

.old-price {
  color: #9aa0a6;
  font-size: 0.9em;
}

.discount-badge {
  align-self: center;
  background: #dc3545;
  color: #fff;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 999px;
}

.is-compact {
  justify-content: center;
  font-size: 0.9rem;
}
</style>
